import { LOAD_JOB_ITEMS_SUCCESS } from '../../actions/types';

const INITIAL_STATE = [];

export default (state=INITIAL_STATE, action) => {
    switch(action.type) {
        case LOAD_JOB_ITEMS_SUCCESS:
            return action.payload;
        default: 
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/jobhistory/JobItemsReducer.js